import {
    Box,
    Button,
    Typography,
} from '@mui/material'
import React, { useState } from 'react'
import AppLoanHowWork from '../../../containers/App-PersonalLoan/HowWork'
import AppMotorHowWork from '../../../containers/App-MotorcycleFinancing/HowWork'
import { useTranslation } from 'react-i18next'

export const SMAppHomeSteps: React.FC = () => {
    const { t } = useTranslation()

    const [tabIndex, updateTabIndex] = useState(0)

    const changeTabIndex = (index: number) => {
        updateTabIndex(index)
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            // paddingLeft: '12px',
            // paddingRight: '12px',
        }}>
            <Typography width={'100%'} textAlign={'center'} paddingTop={'60px'} paddingBottom={'40px'} paddingLeft={'12px'} paddingRight={'12px'} color={'#141F39'} fontSize={24} fontWeight={700}>
                {t('t38')}
            </Typography>

            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Button key={0} onClick={() => changeTabIndex(0)}
                    variant='contained'
                    sx={{
                        borderRadius: '30px',
                        backgroundColor: 0 === tabIndex ? '#FFC107' : '#FFFDF7',
                        border: 0 === tabIndex ? 'none' : '1px solid #141F39',
                        width: '200px',
                        height: '60px',
                        color: '#141F39',
                        textTransform: 'none',
                        '&:hover': {
                            bgcolor: 0 === tabIndex ? 'rgba(251, 191, 35, 0.8)' : 'rgba(20, 31, 57, 0.1)',
                        },
                    }}
                >
                    {t('t39')}
                </Button>
                <Box height={12}></Box>
                <Button key={1} onClick={() => changeTabIndex(1)}
                    sx={{
                        borderRadius: '30px',
                        backgroundColor: 1 === tabIndex ? '#FFC107' : '#FFFDF7',
                        border: 1 === tabIndex ? 'none' : '1px solid #141F39',
                        width: '200px',
                        height: '60px',
                        color: '#141F39',
                        textTransform: 'none',
                        '&:hover': {
                            bgcolor: 1 === tabIndex ? 'rgba(251, 191, 35, 0.8)' : 'rgba(20, 31, 57, 0.1)',
                        },
                    }}
                >
                    {t('t40')}
                </Button>
            </Box>
            <div>
                {1 === tabIndex ? <AppLoanHowWork /> : <AppMotorHowWork />}
            </div> 

        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeSteps
